<template>
  <div class="container-dashboard">
      <div class="container-dashboard-content">
        <VuePerfectScrollbar class="sidebar-left" v-once>
            <div class="sidebar-left-header">
              Notification
            </div>
            <template  v-for="(notification, index) in notifications">
              <div class="sidebar-left-body" :key="index">
                <div class="sidebar-left-item sidebar-title">
                  {{ notification.title }}
                </div>
                <template v-for="(itemsNotification, indexNotification) in notification.data">
                  <a class="sidebar-left-item sidebar-content" href="javascript:void(0)" :key="indexNotification">
                    <div class="content-title">{{ itemsNotification.title }}</div>
                    <div class="content-date">{{ itemsNotification.date }}</div>
                  </a>
                </template>
              </div>
            </template>
        </VuePerfectScrollbar>
        <div class="content">
          <b-container fluid>
            <b-row>
              <b-col cols="12">
                <ApprovalBox @selectedType="handleSelectedType"/>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" class="pr-0">
                <ApprovalAwaiting :type_selected="type_check" @rowClick="handleShowModalApproval"/>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
      <ModalApprovalOrder :id="item_id" ref="approvalOrder"/>
      <ModalApprovalPV :id="item_id" ref="approvalPayment"/>
      <ModalApprovalCreditNote :id="item_id" ref="approvalCreditNote"/>
      <ModalApprovalOffset :id="item_id" ref="approvalOffset"/>
  </div>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  const ApprovalBox = () => import('./dashboard-approval/approval-box')
  const ApprovalAwaiting  = () => import('./dashboard-approval/approval-awaiting')
  const ModalApprovalOrder = () => import('./dashboard-approval/modal-approval-order')
  const ModalApprovalPV = () => import('./dashboard-approval/modal-approval-payment')
  const ModalApprovalCreditNote = () => import('./dashboard-approval/modal-approval-credit-note')
  const ModalApprovalOffset = () => import('./dashboard-approval/modal-approval-offset')

  export default {
    components: {
      VuePerfectScrollbar,
      ApprovalBox,
      ApprovalAwaiting,
      ModalApprovalOrder,
      ModalApprovalPV,
      ModalApprovalCreditNote,
      ModalApprovalOffset
    },
    data: function() {
      return {
        notifications: [
          {
            'title': 'Today 11/07/2019',
            'data': [
              {'title':'PWO-HDB-1808-9044 request to approve','date':'FM-TPL $1,637.50'},
              {'title':'PWO-HDB-1808-9044 request to approve','date':'FM-TPL $1,637.50'},
              {'title':'PWO-HDB-1808-9044 request to approve','date':'FM-TPL $1,637.50'},
              {'title':'PWO-HDB-1808-9044 request to approve','date':'FM-TPL $1,637.50'},
            ]
          },
          {
            'title': 'Yesterday 10/07/2018',
            'data': [
              {'title':'PWO-HDB-1808-9044 request to approve','date':'FM-TPL $1,637.50'},
              {'title':'PWO-HDB-1808-9044 request to approve','date':'FM-TPL $1,637.50'},
              {'title':'PWO-HDB-1808-9044 request to approve','date':'FM-TPL $1,637.50'},
              {'title':'PWO-HDB-1808-9044 request to approve','date':'FM-TPL $1,637.50'},
              {'title':'PWO-HDB-1808-9044 request to approve','date':'FM-TPL $1,637.50'},
              {'title':'PWO-HDB-1808-9044 request to approve','date':'FM-TPL $1,637.50'},
            ]
          }
        ],
        item_id: null,
        type_check: 'all'
      }
    },
    methods: {
      handleSelectedType(type) {
        this.type_check = type;
      },
      async handleShowModalApproval(item) {
        this.item_id = await item.id;
        switch (item.type_check) {
          case 1:
            await this.$refs.approvalOrder.getData(this.item_id);
            break;
          case 4:
            await this.$refs.approvalCreditNote.getData(this.item_id);
            break;
          case 5:
            await this.$refs.approvalOffset.getData(this.item_id);
            break; 
          default:
            await this.$refs.approvalPayment.getData(this.item_id);
            break; 
        }
      }
    }
  }
</script>